const Price = {
  // pdf价格
  "--theme-pdf-price-tag-bg": "#F2F4F3",
  "--theme-pdf-price-tag-bg-hover": "#252325",
  "--theme-pdf-price-tag-color": "#111112",
  "--theme-pdf-price-tag-color-hover": "#FFFFFF",

  "--theme-pdf-price-li-color": "#4B4B4C",
  "--theme-pdf-price-li-color-hover": "#fff",

  "--theme-pdf-price-tips-color": "#7D7D7F",
  "--theme-pdf-price-tips-color-hover": "#AFAFB2",
  "--theme-pdf-price-tips-bg": "#E2E2E5",
  "--theme-pdf-price-tips-bg-hover": "#4B4B4C",

  "--theme-pdf-price-color": "#FF4867",
  "--theme-pdf-price-color-hover": "#FF4867",

  "--theme-pdf-price-inner-bg": "#F2F4F3",
  "--theme-pdf-price-inner-bg-hover": "#252325",

  "--theme-pdf-price-btn": "#463699",
  "--theme-pdf-price-btn-hover": "#fff",

  "--theme-pdf-price-btn-color": "#fff",
  "--theme-pdf-price-btn-color-hover": "#463699",
}

const Questions = {
  // PDF
  // PDF quetions
  "--theme-pdf-questions-title-color": "#fff",
  "--theme-pdf-quesions-bg": "#463699",
  "--theme-pdf-quesions-inner-bg": "#463699",

  "--theme-pdf-quesions-item-bg": "#463699",
  "--theme-pdf-quesions-item-title-color": "#fff",
  "--theme-pdf-quesions-item-title-color-hover": "#fff",

  "--theme-pdf-question-icon-filter": "brightness(100)",

  "--theme-pdf-quesions-item-des-color": "rgba(255,255,255,0.7)",
}


const Steps = {
  "--theme-pdf-step-bg": "#F2F4F3",
  "--theme-pdf-step-subtitle-color": "#111112",
  "--theme-pdf-step-inner-bg": "#fff"
}

const Explain = {
  "--theme-pdf-explain-inner-bg": "white",
}

const Comment = {
  "--theme-pdf-comment-item-bg-hover": "#463699",
}

export const coustomPDFdarkPurpleTheme = {
  //主题背景颜色
  "--theme-primary": "#463699",
  //默认黑
  "--theme-primary-black": "#252325",
  //默认白
  "--theme-primary-white": "#ffffff",
  // 页脚 logo 字体颜色
  "--theme-primary-footer-logo-suffix": "#463699",
  // 登录按钮 字体颜色
  "--theme-primary-login-btn-suffix": "#fff",
  // 不透明度70%
  "--theme-primary-white-70": "#b2b2b2",
  //主题亮色
  "--theme-primary-suffix": "#463699",
  //主题深副色
  "--theme-primary-dark-sub": "#E4430F",
  //主题浅副色
  "--theme-primary-light-sub": "#FF8761",
  //价格 tag
  "--theme-primary-price-tag": "#4C3626",
  "--theme-primary-price-tag-bg": "#FFCF52",
  //tiny 类
  "--theme-primary-tiny": "#666166",
  //footer 背景色
  "--theme-primary-footer-bg": "#000000",
  //输入框聚焦
  "--theme-focus": "#3377ff",
  //输入框错误
  "--theme-focus-err": "#ea3042",

  ...Price,
  ...Questions,
  ...Steps,
  ...Explain,
  ...Comment
}